import {LayoutFooterDark} from './LayoutFooterDark';
import {LayoutFooterLight} from './LayoutFooterLight';
import {LayoutFooterSubscribe} from './LayoutFooterSubscribe';

import {prebuiltLayoutPreviewImages} from '../constants';

const category = 'Footer';

export const FooterDark = {
  category,
  displayName: 'Footer Dark',
  previewImageURL: prebuiltLayoutPreviewImages.layoutFooterDark,
  layout: LayoutFooterDark,
};

export const FooterLight = {
  category,
  displayName: 'Footer Light',
  previewImageURL: prebuiltLayoutPreviewImages.layoutFooterLight,
  layout: LayoutFooterLight,
};

export const FooterSubscribe = {
  category,
  displayName: 'Footer Subscribe',
  previewImageURL: prebuiltLayoutPreviewImages.layoutFooterSubscribe,
  layout: LayoutFooterSubscribe,
};
